import { render } from "./EmptyCards.vue?vue&type=template&id=2e8eede8&scoped=true"
import script from "./EmptyCards.vue?vue&type=script&lang=js"
export * from "./EmptyCards.vue?vue&type=script&lang=js"

import "./EmptyCards.vue?vue&type=style&index=0&id=2e8eede8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8eede8"]])

export default __exports__